import * as klaro from "./klaro/dist/klaro-no-translations-no-css";
import * as cookies from "./cookiemanagement";

declare const window: {
    showCookieSettings: () => void;
};


// By default, Klaro will load the config from  a global "klaroConfig" variable.
// You can change this by specifying the "data-config" attribute on your
// script take, e.g. like this:
// <script src="klaro.js" data-config="myConfigVariableName" />
// You can also disable auto-loading of the consent notice by adding
// data-no-auto-load=true to the script tag.
const klaroConfig = {
    // You can customize the ID of the DIV element that Klaro will create
    // when starting up. If undefined, Klaro will use 'klaro'.
    elementID: "klaro",

    // How Klaro should store the user's preferences. It can be either 'cookie'
    // (the default) or 'localStorage'.
    storageMethod: "cookie",

    // You can customize the name of the cookie that Klaro uses for storing
    // user consent decisions. If undefined, Klaro will use 'klaro'.
    cookieName: "klaro",

    // You can also set a custom expiration time for the Klaro cookie.
    // By default, it will expire after 120 days.
    cookieExpiresAfterDays: 365,

    htmlTexts: true,
    // You can change to cookie domain for the consent manager itself.
    // Use this if you want to get consent once for multiple matching domains.
    // If undefined, Klaro will use the current domain.
    //cookieDomain: '.github.com',

    // Put a link to your privacy policy here (relative or absolute).
    privacyPolicy: "https://admill.dk/terms-and-privacy-policy/",

    // Defines the default state for applications (true=enabled by default).
    default: false,

    // If "mustConsent" is set to true, Klaro will directly display the consent
    // manager modal and not allow the user to close it before having actively
    // consented or declines the use of third-party apps.
    mustConsent: false,

    noticeAsModal: true,

    // Show "accept all" to accept all apps instead of "ok" that only accepts
    // required and "default: true" apps
    acceptAll: true,

    // replace "decline" with cookie manager modal
    hideDeclineAll: true,

    // You can define the UI language directly here. If undefined, Klaro will
    // use the value given in the global "lang" variable. If that does
    // not exist, it will use the value given in the "lang" attribute of your
    // HTML tag. If that also doesn't exist, it will use 'en'.
    lang: "da",

    // You can overwrite existing translations and add translations for your
    // app descriptions and purposes. See `src/translations/` for a full
    // list of translations that can be overwritten:
    // https://github.com/KIProtect/klaro/tree/master/src/translations

    // Example config that shows how to overwrite translations:
    // https://github.com/KIProtect/klaro/blob/master/src/configs/i18n.js
    translations: {
        da: {
            title: "Cookies",
            ok: "Acceptera",
            decline: "Afvis",
            acceptSelected: "Acceptera vald",
            acceptAll: "Acceptera alla",
            consentNotice: {
                icon: "/images/cookie-icon.svg",
                title: "COOKIES",
                description:
                    "ClaraFinans använder cookies som hjälper oss att erbjuda dig den bästa servicen. Du kan läsa hur vi använder informationen i vår {privacyPolicy} <br/><br/>Accepterar du användningen av cookies?",
                changeDescription: " ",
                learnMore: "Anpassa cookies",
            },
            privacyPolicy: {
                text:
                    "Du kan läsa mer i vår {privacyPolicy}",
                name: "Personuppgiftspolicy",
            },
            consentModal: {
                icon: "/images/cookie-icon.svg",
                title: "Detta är vad vi samlar in",
                description:
                    "Vi använder cookies till statistik och målinriktad marknadsföring för vår sida och för 3 andra samarbetspartners.",
                privacyPolicy: {
                    text:
                        "Du kan läsa mer i vår {privacyPolicy}",
                    name: "Personuppgiftspolicy",
                },
            },
            purposeItem: {
                service: "service",
                services: "services",
            },
            poweredBy: "Klaro",
            save: "Bekräfta val",
            purposes: {
                analytics: "Statistik",
                support: "Kundsupport",
                marketing: "Marknadsföring",
            },
            service: {
                purpose: "Föremål",
                required: {
                    title: "Nödvändig",
                },
                disableAll: {
                    title: "Välj till/ från alla",
                    description: "använd denna knapp för att Välj till/från alla",
                },
            },
            "google-analytics": {
                description: "",
            },
        },
    },

    // This is a list of third-party services that Klaro will manage for you.
    services: [
        // The services will appear in the modal in the same order as defined here.
        {
            name: "googleadw",
            default: true,
            title: "Google Adwords",
            description: "Behandling av reklam baserat på trafik.",
            purposes: ["marketing"],
            cookies: ["gclid"],
            callback: function (consent) {
                if (consent) {
                    cookies.thirdPartyPresent(true);
                    cookies.loadGoogle();
                }
            },
        },
        {
            name: "facebookclid",
            default: true,
            title: "Facebook",
            description: "Behandling av reklam baserat på trafik.",
            purposes: ["marketing"],
            cookies: ["fbclid", "_fbp", "_fbc"],
            callback: function (consent) {
                if (consent) {
                    cookies.thirdPartyPresent(true);
                    cookies.loadFacebook();
                }
            },
        },
        {
            name: "heyloyalty",
            default: true,
            title: "Heyloyalty",
            description: "Behandling av information av kampanjer",
            purposes: ["marketing"],
            cookies: ["heypushPermissionClosed"],
            callback: function (consent) {
                if (consent) {
                    cookies.thirdPartyPresent(true);
                    cookies.loadFacebook();
                }
            },
        },
        {
            name: "internaltmarketing",
            default: true,
            title: "Intern Marketing",
            description: "Behandling av information av kampanjer",
            purposes: ["marketing"],
            cookies: [
                "bilhandel",
                "tldCatId",
                "emailtrackingid",
                "referrer",
                "userid"
            ],
            callback: function (consent) {
                cookies.loadInternalCookies(consent);
            },
        },
        {
            name: "clarity",
            default: true,
            title: "Clarity Analytics",
            description: "Användarupplevelsestatistik",
            purposes: ["analytics"],
            cookies: [
                "_clck",
                "_clsk",
                "CLID",
                "ANONCHK",
                "MR",
                "MUID",
                "SM"
            ],
        },
        {
            name: "sendinblue",
            default: true,
            title: "SendInBlue Analytics",
            description: "Statistik för email marketing",
            purposes: ["analytics"],
            cookies: ["sib_cuid"],
        },
    ],
};


klaro.setup(klaroConfig);



window.showCookieSettings = () => {
    klaro.show(klaroConfig);
}